import React, { Suspense, lazy } from "react";
import { createBrowserRouter } from "react-router-dom";

// route names
import { ROUTE_NAMES } from "./names";

// pages
import StripeCardPayment from "views/StripePayment/CardPayment";
import StripeIdealPayment from "views/StripePayment/IdealPayment";
import StripeSocialPayment from "views/StripePayment/SocialPayment";
import TikkiePaymentVerification from "views/TikkiePaymentVerification";

// components
import { GlobalFooter, Loader } from "components";
import TikkiePayment from "views/TikkiePayment";

const SuspenseFallback = () => (
  <div className="ticket-view-loading">
    <Loader />
  </div>
);

const withSuspenseFallback = (WrappedComponent) => {
  return (props) => (
    <Suspense fallback={<SuspenseFallback />}>
      <WrappedComponent {...props} />
    </Suspense>
  );
};

const withGlobalFooter = (WrappedComponent) => {
  return (props) => (
    <>
      <WrappedComponent {...props} />
      {/* <GlobalFooter /> */}
    </>
  );
};

// Pages
const TicketLoading = withGlobalFooter(
  withSuspenseFallback(lazy(() => import("views/TicketLoading")))
);

const ErrorBookingLink = withGlobalFooter(
  withSuspenseFallback(lazy(() => import("views/ErrorBookingLink")))
);

const TicketBooking = withGlobalFooter(
  withSuspenseFallback(lazy(() => import("views/TicketBooking")))
);

const StripeCardPaymentWithFooter = withGlobalFooter(StripeCardPayment);

const StripeIdealPaymentWithFooter = withGlobalFooter(StripeIdealPayment);

const StripeSocialPaymentWithFooter = withGlobalFooter(StripeSocialPayment);

const TikkiePaymentVerificationWithFooter = withGlobalFooter(
  TikkiePaymentVerification
);

const StripePaymentCheck = withGlobalFooter(
  withSuspenseFallback(lazy(() => import("views/StripePayment/CheckPayment")))
);

const StripePaymentComplete = withGlobalFooter(
  withSuspenseFallback(
    lazy(() => import("views/StripePayment/PaymentComplete"))
  )
);

const OrderConfirmation = withGlobalFooter(
  withSuspenseFallback(lazy(() => import("views/OrderConfirmation")))
);

const AddToMyCalender = withGlobalFooter(
  withSuspenseFallback(lazy(() => import("views/AddToMyCalender")))
);

const TicketScan = withGlobalFooter(
  withSuspenseFallback(lazy(() => import("views/TicketScan")))
);

const GetTicket = withGlobalFooter(
  withSuspenseFallback(lazy(() => import("views/GetTicket")))
);

const WebShop = withGlobalFooter(
  withSuspenseFallback(lazy(() => import("views/WebShop")))
);
const ShopOrderConfirmation = withGlobalFooter(
  withSuspenseFallback(lazy(() => import("views/WebShop/ShopOrderConfirmation")))
);
const OnsiteSale = withGlobalFooter(
  withSuspenseFallback(lazy(() => import("views/OnsiteSale")))
);

const router = createBrowserRouter([
  {
    path: ROUTE_NAMES.LANDING_ERROR,
    element: <ErrorBookingLink />,
  },
  // {
  //   path: ROUTE_NAMES.LANDING,
  //   element: <TicketLoading />,
  // },
  {
    path: ROUTE_NAMES.LANDING,
    element: <TicketBooking compSteps={1} />,
  },
  {
    path: ROUTE_NAMES.BOOKING,
    element: <TicketBooking compSteps={1} />,
  },
  {
    path: ROUTE_NAMES.BOOKING_PAYMENTS,
    element: <TicketBooking compSteps={2} />,
  },
  {
    path: ROUTE_NAMES.CARD_PAYMENT,
    element: <StripeCardPaymentWithFooter />,
  },
  {
    path: ROUTE_NAMES.IDEAL_PAYMENT,
    element: <StripeIdealPaymentWithFooter />,
  },
  {
    path: ROUTE_NAMES.SOCIAL_PAYMENT,
    element: <StripeSocialPaymentWithFooter />,
  },
  {
    path: ROUTE_NAMES.PAYMENT_CHECK,
    element: <StripePaymentCheck />,
  },
  {
    path: ROUTE_NAMES.PAYMENT_COMPLETE,
    element: <StripePaymentComplete />,
  },
  {
    path: ROUTE_NAMES.TIKKIE_PAYMENT,
    element: <TikkiePayment />,
  },
  {
    path: ROUTE_NAMES.TIKKIE_PAY_CHECK,
    element: <TikkiePaymentVerificationWithFooter />,
  },
  {
    path: ROUTE_NAMES.ORDER_CONFIRMATION,
    element: <OrderConfirmation />,
  },
  {
    path: ROUTE_NAMES.SCAN_TICKET,
    element: <TicketScan />,
  },
  {
    path: ROUTE_NAMES.GET_TICKET,
    element: <GetTicket />,
  },
  {
    path: ROUTE_NAMES.ONSITE_SALE,
    element: <OnsiteSale />,
  },
  {
    path: ROUTE_NAMES.WEB_SHOP,
    element: <WebShop />,
  },
  {
    path: ROUTE_NAMES.SHOP_ORDER,
    element: <ShopOrderConfirmation />,
  },
]);

export default router;
